// not the best way but such is life
export const coinPrecisions: Record<string, number> = {
  USDT: 2,
  USDC: 2,
  BTC: 8,
};
